import { getLocale } from '@/i18n';
import { store } from '@/store';
import uniqArray from '@/utils/arrays';
import router from '@/router';

const updateTranslation = async (keys: string[], code: string): Promise<void> => {
  try {
    await store.dispatch('TranslateModule/getAsyncData', { code, keys });
  } catch (e) {
    throw new Error(e);
  }
};

const updateMenu = async (code: string): Promise<void> => new Promise((resolve, reject) => store.dispatch('MenuModule/getAsyncData', code)
  .then((keys) => {
    const lhnKeys = Object.keys(store.state.LHNJSSDKModule.dictionary).map((item: string) => store.state.LHNJSSDKModule.dictionary[item]) as [];
    const constants = store.getters['ConstantsModule/list'];
    updateTranslation(uniqArray(keys, constants.concat(lhnKeys)), code)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  })
  .catch((e) => {
    console.warn(e);
    reject(e);
  }));

const updatePayments = (): void => {
  const path = store.getters['ConfigsModule/paymentsUrl'];
  const alias = store.getters['ConfigsModule/staticPaymentsUrl'];

  router.addRoutes(
    [
      {
        path,
        alias,
        name: 'Payments',
        meta: {
          type: 'payments',
        },
        component: () => import(/* webpackChunkName: "payments" */ '../views/Payments.vue'),
      },
    ],
  );
};

const updateConfig = (code: string) => new Promise((resolve, reject) => store.dispatch('ConfigsModule/getAsyncData', code)
  .then(() => {
    updatePayments();
    updateMenu(code)
      .then(() => resolve())
      .catch((e) => {
        reject(e);
      });
  })
  .catch((e) => {
    reject(e);
  }));

const prefetchData = (): Promise<void> => new Promise((resolve, reject) => {
  const code = getLocale();
  updateConfig(code)
    .then(() => {
      store.commit('ConstantsModule/setConstantsState', true);
      store.commit('MenuModule/setMenuState', true);
      resolve();
    })
    .catch((e) => {
      reject(e);
    });
});

export default prefetchData;
